import HotRankList from '@/components/feature/HotRankList';
import { gossipCategories, gossipTopics, hotSearchList } from '@/mocks/gossip';

interface TopicsSidebarProps {
  activeCat: string;
  onSelectCategory: (slug: string) => void;
}

const allTags = ['顶流男星', '换角', '恋综', '剪辑争议', '音乐节', '解约', '红毯', '时间线'];

export default function TopicsSidebar({ activeCat, onSelectCategory }: TopicsSidebarProps) {
  return (
    <aside className="flex flex-col gap-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="font-heading text-sm font-bold tracking-wide text-foreground-950">内容分类</h2>
        <ul className="mt-3 flex flex-col gap-1">
          {gossipCategories.map((cat) => {
            const isActive = activeCat === cat.slug;
            return (
              <li key={cat.slug}>
                <button
                  type="button"
                  onClick={() => onSelectCategory(cat.slug)}
                  className={`flex w-full cursor-pointer items-center gap-2.5 rounded-md px-3 py-2.5 text-left text-[13px] transition-colors ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <i className={cat.icon} aria-hidden="true" />
                  <span className="flex-1 font-medium">{cat.name}</span>
                  <span className={`text-[11px] ${isActive ? 'text-background-100/80' : 'text-foreground-400'}`}>
                    {cat.count}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      <HotRankList items={hotSearchList} title="实时讨论榜" />

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="font-heading text-sm font-bold tracking-wide text-foreground-950">热门标签</h2>
        <div className="mt-3 flex flex-wrap gap-2">
          {allTags.map((tag) => (
            <span
              key={tag}
              className="cursor-default rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-medium text-secondary-800 transition-colors hover:bg-accent-100 hover:text-accent-900"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100 p-4">
        <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
          <i className="ri-information-line text-secondary-600" aria-hidden="true" />
          阅读提示
        </h2>
        <p className="mt-2 text-xs leading-relaxed text-foreground-600">
          列表中的「证据完整度」为粗略分级，仅作参考。共 {gossipTopics.length} 条记录正在跟踪，其中部分条目会随新信息更新。
        </p>
      </div>
    </aside>
  );
}